import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import { IRmOp } from "interface/book";
import { modalControl, priceFormat, successControl } from "util/commAction";
import {
  BookInfProvider,
  useBookInfContext,
} from "components/context/bookInfContext";
import { useMutation } from "@tanstack/react-query";
import { resvPdApi } from "components/api/book";
import RmDetail from "./detail";

type IPackage = {
  type: "modal" | "web";
  opInf: IRmOp;
  rmPdNo: string;
};

const PackageRow = ({ type, opInf, rmPdNo }: IPackage) => {
  const { t } = useTranslation();
  const lodInf = localStorage.getItem("lodInf")
    ? JSON.parse(localStorage.getItem("lodInf") ?? "")
    : undefined;
  const { bookInf, onBookInf } = useBookInfContext();

  const resvPdMutation = useMutation({
    mutationFn: resvPdApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            if (type !== "modal") {
              onBookInf({
                ...res.data,
                rmTypNm: opInf.rmTypNm,
                rmNm: opInf.rmNm,
                rmOpNm: opInf.rmOpNm,
                brkfInYn: opInf.brkfInYn,
                rmInf: [
                  {
                    ...res.data,
                    rmTypNm: opInf.rmTypNm,
                    rmNm: opInf.rmNm,
                    rmOpNm: opInf.rmOpNm,
                    brkfInYn: opInf.brkfInYn,
                  },
                ],
              });
            }

            if (type === "modal") {
              modalControl({
                isOpen: false,
              });

              const bookInfEvent = new CustomEvent("modalBookInfDispatch", {
                detail: {
                  rmInf: {
                    ...res.data,
                    rmTypNm: opInf.rmTypNm,
                    rmNm: opInf.rmNm,
                    rmOpNm: opInf.rmOpNm,
                    brkfInYn: opInf.brkfInYn,
                    rmInf: [
                      {
                        ...res.data,
                        rmTypNm: opInf.rmTypNm,
                        rmNm: opInf.rmNm,
                        rmOpNm: opInf.rmOpNm,
                        brkfInYn: opInf.brkfInYn,
                      },
                    ],
                  },
                  target: "bookInfEvent",
                },
              });
              window.dispatchEvent(bookInfEvent);
              // }
            }
          },
        });
      }
    },
  });

  const handleSelectPrd = () => {
    //선택됱 패키지 확인
    // resvPdApi
    const { adltCnt, dates, childCnt, rmCnt } = bookInf;
    const params = {
      rmNo: opInf.rmNo,
      opRgSeq: opInf.opRgSeq,
      resvSDt: dates[0] ?? undefined,
      resvEDt: dates[1] ?? undefined,
      resvRmCt: rmCnt ?? 1,
      adltPerCt: adltCnt ?? lodInf?.defAdltPerCt,
      chldPerCt: childCnt ?? 0,
    };

    resvPdMutation.mutate(params);
  };

  return (
    <>
      <li className="between-center gap-6">
        <div className="between-center flex-1">
          <h4>{opInf.rmOpNm}</h4>
          <h4 className="text-blue-300">
            {opInf.minSellPri === opInf.maxSellPri
              ? priceFormat(opInf.minSellPri)
              : priceFormat(opInf.minSellPri) +
                " ~ " +
                priceFormat(opInf.maxSellPri)}
          </h4>
        </div>
        <div className="flex gap-2">
          {/* <Button
            text={t("btn_dtl")}
            styels="bg-white radius-4 w-[77px]"
            onClick={() => {
              //상세정보 보기
              //객실정보 상세 보기
              modalControl({
                isOpen: true,
                styles: "p-4  md:p-8 max-w-[700px]",
                chckBtn: false,
                inner: (
                  <BookInfProvider>
                    <RmDetail rmPdNo={rmPdNo} />
                  </BookInfProvider>
                ),
              });
            }}
          /> */}
          <Button
            text={t("btn_slt_bk")}
            styels="w-[77px] radius-4"
            onClick={handleSelectPrd}
          />
        </div>
      </li>
    </>
  );
};

type IProps = {
  type?: "modal" | "web";
  packageList: IRmOp[];
  rmPdNo: string;
};

export default function Package({
  packageList = [],
  type = "web",
  rmPdNo,
}: IProps) {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="ttl">{t("bck_pck_stl_bk")}</h4>
      <ul className="">
        {packageList.length === 0 && (
          <li className="center text-blue-300 pb-6">
            {t("bk_no_data_info_bk")}
          </li>
        )}
        {packageList.map((opInf) => {
          return (
            <PackageRow
              key={opInf.opRgSeq}
              opInf={opInf}
              type={type}
              rmPdNo={rmPdNo}
            />
          );
        })}
      </ul>
    </>
  );
}
